import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import Search from '@ifeng-fe/ui_pc_search';
import Logo from '../logo/index';

class corpHeader extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { logo, search } = this.props.content;

        const SearchComp = errorBoundary(Search);

        return (
            <div id="main_nav" className={styles.header}>
                <div className={styles.header_l}>
                    <Chip id="50055" type="struct" title="logo" groupName="顶部" content={logo}>
                        <Logo />
                    </Chip>
                </div>
                <div className={styles.header_r}>
                    <div className={styles.login}>
                        <div className={styles.user}>
                            <UserInfo iconShow option={['login']} />
                        </div>
                        <div className={styles.search}>
                            <Chip id="20005" type="struct" title="搜索" groupName="顶部" content={search}>
                                <SearchComp expand />
                            </Chip>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(corpHeader);
